import React from "react"
import { Link } from "gatsby"

const MobilePages = () => {
    return (
        <div className="mobile-pages-main bg-dark text-white border-top">
            <div className="row p-0">
                <p className="col text-center my-auto py-1"><Link to="/"><span className="text-white">HOME</span></Link></p>
                <p className="col text-center my-auto"><Link to="/about"><span className="text-white">ABOUT</span></Link></p>
                <p className="col text-center my-auto"><Link to="/archive"><span className="text-white">ARCHIVE</span></Link></p>
            </div>
        </div>
    )
}

export default MobilePages


